module.exports = __webpack_public_path__ + "media/images/weather/411_day-8a7682edf3fe43f072ec4e4fab992396.png";